module.exports = __webpack_public_path__ + "static/media/service6.7c57553b.png";